import { Base } from 'layouts'
import { UserForm } from 'components'

import * as S from './styled'

export function UserEdit() {
  return (
    <Base>
      <S.GridContainer container>
        <UserForm />
      </S.GridContainer>
    </Base>
  )
}
